<template>
  <div class="col-span-1 sm:col-span-2">
    <span class="mb-1.5 block leading-normal text-zinc-800">
      {{ __('Add photo gallery (max. 6 photos)') }} *
    </span>

    <div
      class="grid grid-cols-2 gap-2 py-2 sm:grid-cols-3 sm:gap-3 md:grid-cols-4 md:gap-4"
    >
      <UploadImage
        v-if="allImages.length < 6"
        :class="`${allImages.length ? (allImages.length === 6 ? 'hidden' : 'block') : 'col-span-2 sm:col-span-3 md:col-span-4'}`"
        @change="handleUploadImage"
      />
      <Image
        v-for="(item, index) in allImages"
        :key="item"
        :image="item"
        :has_primary_photo_logic="true"
        :is_primary="item.is_primary === 1 || item.is_primary === true"
        @checked="itemChecked(item)"
        @delete="handleDeleteImageButtonClick(index)"
      />
    </div>

    <span
      v-if="errors?.images"
      class="mt-1.5 block text-xs leading-normal text-red-500"
    >
      {{ errors?.images[0] }}
    </span>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import { __ } from '@/helpers';
  import Image from '../../company-profile/components/media/components/media-edit/components/image/image.vue';
  import UploadImage from '../../company-profile/components/media/components/media-edit/components/upload-image/upload-image.vue';

  const props = defineProps({
    data: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  });
  function handleDeleteImageButtonClick(index) {
    if (props.data.product.deleted_images_ids === undefined) {
      props.data.product.deleted_images_ids = [];
    }
    if (props.data.product.images[index]?.id) {
      props.data.product.deleted_images_ids.push(
        props.data.product.images[index].id
      );

      props.data.product.images = props.data.product.images.filter(
        (_, i) => i !== index
      );
    } else {
      props.data.product.uploaded_images =
        props.data.product.uploaded_images.filter(
          (_, i) => i !== index - props.data.product.images.length
        );
    }
  }

  function handleUploadImage(base64, file) {
    if (props.data.product.images.length >= 6) {
      return;
    }
    if (props.data.product.uploaded_images === undefined) {
      props.data.product.uploaded_images = [];
    }
    props.data.product.uploaded_images.push({
      url: base64,
      file: file,
      type: 'image',
      is_primary:
        allImages.value.length === 0 || !primaryPhotoExists ? true : false
    });
  }

  const primaryPhotoExists = computed(() => {
    return (
      props.data.product.images?.some((image) => image.is_primary) ||
      props.data.product.uploaded_images?.some(
        (image) => image.is_primary === true
      )
    );
  });

  const itemChecked = (item) => {
    item.is_primary = !item.is_primary;

    allImages.value
      .filter((currentItem) => currentItem != item)
      .map((currentItem) => (currentItem.is_primary = false));
  };

  const allImages = computed(() =>
    (props.data.product.images || []).concat(
      props.data.product.uploaded_images || []
    )
  );
</script>
